// extracted by mini-css-extract-plugin
export default {"container":"qh1FLz","title":"OHOL5h","text":"SmeIyj"};